<template>
	<div class="accountManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">账号管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">账号列表</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增账号"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.search" placeholder="请输入账号/名称/手机号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.roleId" slot="prepend" placeholder="请选择角色">
								<el-option v-for="(item,inx) in personList" :key="inx" :label="item.roleName"
									:value="item.roleId"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend"
								placeholder="请选择所属运营商">
								<el-option v-for="(item,inx) in serviceList" :key="inx"
									:label="item.serviceProviderName" :value="item.serviceProviderId"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.loginStatus" slot="prepend" placeholder="请选择状态">
								<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="loginName" label="账号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userName" label="名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userPhone" label="手机号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="jobName" label="岗位">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="roleName" label="角色">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="serviceProviderName" label="所属运营商">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="loginStatus" label="状态">
								<template slot-scope="scope">
									<span>{{scope.row.loginStatus==1?"使用中":scope.row.loginStatus==2?"禁用":''}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="180">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,3)">重置密码</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="账号名称" prop="loginName">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.loginName" placeholder="请输入账号名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="姓名" prop="userName">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.userName" placeholder="请输入姓名">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="手机号" prop="userPhone">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.userPhone" placeholder="请输入手机号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="岗位">
								<div class="myinputBox">
									<el-select clearable value-key="paramConfigItemName" v-model="creatObj.jobId"
										slot="prepend" placeholder="请选择岗位">
										<el-option v-for="(item,inx) in jobList" :key="inx"
											:label="item.paramConfigItemName"
											:value="item.paramConfigItemId"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="角色" prop="roleId">
								<div class="myinputBox">
									<el-select clearable value-key="roleName" v-model="creatObj.roleId" slot="prepend"
										placeholder="请选择角色">
										<el-option v-for="(item,inx) in personList" :key="inx" :label="item.roleName"
											:value="item.roleId"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属运营商"
								:prop="creatObj.roleId=='UR2023091620544724126102'?'serviceProviderId':'ghj'">
								<div class="myinputBox">
									<el-select clearable value-key="paramConfigItemId"
										v-model="creatObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
										<el-option v-for="(item,inx) in serviceList" :key="inx"
											:label="item.serviceProviderName"
											:value="item.serviceProviderId"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="状态" prop="loginStatus">
								<div class="myinputBox">
									<el-select clearable value-key="value" v-model="creatObj.loginStatus" slot="prepend"
										placeholder="请选择状态">
										<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="初始状态">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.loginPassword" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../assets/js/common.js"
	export default {
		name: "accountManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {},
				dialogVisible: false,
				NOfalse: false,
				dialogTitle: "新增账号",
				levelList: [{
						text: "高级",
						value: 1
					},
					{
						text: "中级",
						value: 2
					},
					{
						text: "初级",
						value: 3
					},
				],
				jobList: [],
				serviceList: [],
				statusList: [{
						text: "使用中",
						value: 1
					},
					{
						text: "禁用",
						value: 2
					}
				],
				tableData: [],
				personList: [],
				loading: false,
				psdValue: "",
				searchObj: {
					search: "", //搜索
					roleId: "", //角色id
					serviceProviderId: "", //运营商id
					loginStatus: null, //账号状态 1使用中 2禁用
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				rules: {
					loginName: [{
						required: true,
						message: '请输入账号名称',
						trigger: 'blur'
					}],
					userName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					userPhone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					jobId: [{
						required: true,
						message: '请输入岗位名称',
						trigger: 'change'
					}],
					roleId: [{
						required: true,
						message: '请选择角色',
						trigger: 'change'
					}],
					serviceProviderId: [{
						required: true,
						message: '请选择运营商',
						trigger: 'change'
					}],
					loginStatus: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}],

				},
			}
		},
		mounted() {
			this.listRole()
			this.selectParamConfigByCode()
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			exportData() {
				let obj = {
					search: this.searchObj.search,
					roleId: this.searchObj.roleId,
					serviceProviderId: this.searchObj.serviceProviderId,
					loginStatus: this.searchObj.loginStatus
				}
				this.$api.exportUserPlatform(obj, "账号列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			listRole() {
				this.$api.listRole({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "personList", res.obj)
					}
				})
			},

			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})
				this.$api.selectParamConfigByCode({
					"paramCode": 1003,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "jobList", res.obj.paramConfigItemList)
					}
				})
				this.$api.selectParamConfigByCode({
					"paramCode": 1004,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "psdValue", res.obj.paramData)
					}
				})
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.dialogTitle == "新增账号") {
							that.addUserPlatform()
						} else {
							that.updateUserPlatform(that.creatObj)
						}
					} else {
						return false;
					}
				});

			},
			updateUserPlatform(item) {
				let obj = {
					loginId: item.loginId,
					loginName: item.loginName,
					loginStatus: item.loginStatus,
					roleId: item.roleId,
					userName: item.userName,
					userPhone: item.userPhone,
					jobId: item.jobId,
					serviceProviderId: item.serviceProviderId,
					loginPassword: item.loginPassword || this.psdValue
				}
				this.$api.updateUserPlatform(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '编辑账号成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			addUserPlatform(item) {

				let obj = {
					loginName: this.creatObj.loginName,
					loginStatus: this.creatObj.loginStatus,
					roleId: this.creatObj.roleId,
					userName: this.creatObj.userName,
					userPhone: this.creatObj.userPhone,
					jobId: this.creatObj.jobId,
					serviceProviderId: this.creatObj.serviceProviderId,
					loginPassword: this.creatObj.loginPassword || this.psdValue
				}
				this.$api.addUserPlatform(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新增账号成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			// 编辑1删除2新增5
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.dialogTitle = "编辑账号"
					this.$set(this, "creatObj",item)
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 5) {
					this.dialogTitle = "新增账号"
					this.$set(this, "creatObj", {
						loginName: "", //账号名称
						loginPassword: "", //账号密码
						loginStatus: "", //账号状态 1使用中 2禁用
						roleId: "", //角色id
						userName: "", //用户名称
						userPhone: "", //电话
						jobId: "", //岗位名称
						serviceProviderId: "" //运营商名称
					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 2) {
					this.$confirm('是否确认删除该账号?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteUserPlatform({
							loginId: item.loginId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData({
										n: 1,
										k: 1
									})
								}, 500)
							}
						})

					}).catch(() => {

					});
				} else if (n == 3) {
					this.$confirm('是否重置该账户的密码?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$set(item, 'loginPassword', that.psdValue)
						that.$nextTick(() => {
							that.updateUserPlatform(item)
						})

					}).catch(() => {

					});
				}
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading = true

				this.$api.listUserPlatform(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.searchObj.pageNo = val
				this.getData({})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./accountManage.scss";
</style>